import React from 'react';
import cn from 'classnames';
import { LazyloadImage, RouterLink } from 'src/components';

interface IProps {
    url: string;
    thumb: string;
    target: string;
    description: string;
    className?: string;
}

export default React.memo(function Banner(props: IProps) {
    const { url, thumb, target, description, className = '' } = props;

    if (!thumb) {
        return null;
    }

    return (
        <RouterLink
            className={cn('section-banner my-[16px] pt-0 block', className)}
            to={url}
            newTab={target === '_blank'}
        >
            <LazyloadImage src={thumb} alt={description} />
        </RouterLink>
    );
});
